import React from 'react';

const NumberColumn = ({ title = '', list = []}) => {
    return (
        <div className='number-column'>
            <div className='container'>
                <h2>{title}</h2>
                <div className={`numbers-list col-${list.length}`}>
                    {list.map((item, key) => {
                        return (
                            <div key={key}>
                                <h4>{item.number}</h4>
                                <p>{item.caption}</p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    )
}

export default NumberColumn;